import JobProApi from 'JobProAPI';
import config from 'config.json';

export default new JobProApi(config.apiUrl, config.oauthToken, {
  useCors: true
});
